import { Card } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import { useAuth } from "context/AuthContext";
import { useState, useEffect } from "react";
import { api } from "services/api";

const SubscriptionDetails = () => {
  const { profile, setProfile } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const latestUserData = await api.get("/me");
        console.log("Dados do usuário recebidos do backend:", latestUserData);
        setProfile(latestUserData); // Atualiza o contexto com os dados mais recentes
      } catch (error) {
        console.error("Erro ao buscar detalhes do usuário:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, [setProfile]);

  if (loading) {
    return (
      <Card sx={{ height: "100%" }}>
        <VuiBox p={2}>
          <VuiTypography color="text" variant="h6" fontWeight="medium">
            Carregando informações...
          </VuiTypography>
        </VuiBox>
      </Card>
    );
  }

  const isActive = profile?.subscription_status === 'active';
  const statusText = isActive ? "Assinatura Ativa" : "Assinatura Inativa";
  const statusColor = isActive ? "success" : "error";

  const handleManageSubscription = () => {
    console.log("Redirecionando para o portal de gerenciamento de assinatura...");
  };

  return (
    <Card sx={{ height: "100%" }}>
      <VuiBox p={2} display="flex" flexDirection="column" justifyContent="space-between" height="100%">
        <VuiBox>
          <VuiTypography variant="lg" fontWeight="bold" color="white">
            Plano e Assinatura
          </VuiTypography>
          <VuiBox mt={2} display="flex" alignItems="center">
            <VuiTypography color={statusColor} variant="h6" fontWeight="medium">
              {statusText}
            </VuiTypography>
          </VuiBox>
        </VuiBox>
        <VuiBox mt={3}>
          <VuiButton 
            variant="contained" 
            color="info" 
            onClick={handleManageSubscription}
          >
            Gerenciar Assinatura
          </VuiButton>
        </VuiBox>
      </VuiBox>
    </Card>
  );
};

export default SubscriptionDetails;
